import React from 'react';

import Shape1 from '../../assets/images/shapes/shape-1.svg';
import Shape8 from '../../assets/images/shapes/shape-8.svg';
import Shape9 from '../../assets/images/shapes/shape-9.svg';

import './style.scss';

import {
  NODE_TYPE_ARTICLE,
  NODE_TYPE_BASIC_PAGE,
  NODE_TYPE_FRONT_PAGE,
  NODE_TYPE_LANDING_PAGE,
  NODE_TYPE_MUNICIPALITY,
} from '../../config/constants';

const determineShape = (type) => {
  switch (type) {
    case NODE_TYPE_FRONT_PAGE: return Shape9;
    case NODE_TYPE_BASIC_PAGE: return Shape1;
    case NODE_TYPE_ARTICLE: return Shape8;
    case NODE_TYPE_MUNICIPALITY: return Shape9;
    case NODE_TYPE_LANDING_PAGE: return Shape9;
    default: return null;
  }
};

const Shape = ({ type }) => {
  const shapeSVG = determineShape(type);

  if (!shapeSVG) {
    return null;
  }

  return (
    <div className={`Shape Shape--${type}`}>
      <img src={shapeSVG} alt="" />
    </div>
  );
};

export default Shape;
